// ST40/ST43 — shared threshold logic for the credit-saturation + VRAM-headroom
// indicators (from the metrics/summary registries). Pure so it is unit-testable.
// Consumed by the Errors aggregation (the Performance view that also used it was
// removed in BF29).

export type Severity = 'ok' | 'warn' | 'bad';

// Credit saturation is a 0..1 (or 0..100) ratio of consumed vs available GPU credits.
// >90% = saturated (bad), >75% = warn.
export function saturationSeverity(value: number): Severity {
  const v = value > 1 ? value / 100 : value;
  if (v >= 0.9) return 'bad';
  if (v >= 0.75) return 'warn';
  return 'ok';
}

// VRAM headroom is free MB on an instance. <512MB = critical, <2048MB = warn.
export function vramHeadroomSeverity(freeMb: number): Severity {
  if (freeMb < 512) return 'bad';
  if (freeMb < 2048) return 'warn';
  return 'ok';
}

export const severityTone: Record<Severity, 'ok' | 'warn' | 'bad'> = {
  ok: 'ok',
  warn: 'warn',
  bad: 'bad',
};
